import request from 'api/request';

export default function readTicketRoute(ticketId) {
  return request({ url: `/tickets/${ticketId}` });
}
